// apiClient.ts
import api from '../../../features/auth/api/axiosInstance';
import { ApiRequest, ApiResponse } from '../../../features/auth/api/apiTypes';
// import { appConstants } from '@shared/constants/global';
// import { mockGet, mockPost } from '@features/auth/api/mockApiClient';
import { AxiosResponse } from 'axios';

/* ---------------- GET ---------------- */
export async function apiGet<T>(
  request: ApiRequest,
): Promise<AxiosResponse<ApiResponse<T>>> {
  console.log('Request', request.endpoint, request.payload);
  if (!request.endpoint) {
    throw new Error('GET request requires endpoint');
  }

  // Uncomment this if using mocks
  // if (appConstants.isMock) {
  //   return mockGet(request.endpoint);
  // }

  const response = await api.get<ApiResponse<T>>(request.endpoint, {
    params: request.params,
    headers: request.headers,
  });

  return response;
}

/* ---------------- POST ---------------- */
export async function apiPost<T>(
  request: ApiRequest,
): Promise<AxiosResponse<ApiResponse<T>>> {
  console.log('Request', request.endpoint, request.payload);
  if (!request.endpoint) throw new Error('POST request requires endpoint');

  const response = await api.post<ApiResponse<T>>(
    request.endpoint,
    request.payload,
    {
      headers: request.headers,
    },
  );

  return response;
}

export async function apiPut<T>(
  request: ApiRequest,
): Promise<AxiosResponse<ApiResponse<T>>> {
  console.log('Request', request.endpoint, request.payload);
  if (!request.endpoint) throw new Error('PUT request requires endpoint');

  const response = await api.put<ApiResponse<T>>(
    request.endpoint,
    request.payload,
    {
      headers: request.headers,
    },
  );

  return response;
}

export async function apiPatch<T>(
  request: ApiRequest,
): Promise<AxiosResponse<ApiResponse<T>>> {
  console.log('Request', request.endpoint, request.payload);
  if (!request.endpoint) throw new Error('PATCH request requires endpoint');

  const response = await api.patch<ApiResponse<T>>(
    request.endpoint,
    request.payload,
    {
      headers: request.headers,
    },
  );

  return response;
}

/* ---------------- DELETE ---------------- */
export async function apiDelete<T>(
  request: ApiRequest,
): Promise<AxiosResponse<ApiResponse<T>>> {
  console.log('Request', request.endpoint, request.payload);
  if (!request.endpoint) throw new Error('DELETE request requires endpoint');

  const response = await api.delete<ApiResponse<T>>(request.endpoint, {
    headers: request.headers,
    data: request.payload,
  });

  return response;
}
